import { ButtonColor } from "@/common/enum/button-color";
import { CheckboxColor } from "@/common/enum/checkbox-color";
import { categoryService } from "@/services/category-service";
import { CategoryDto } from "@/types/dto/category-dto";
import { Button, Checkbox } from "flowbite-react";
import { useEffect, useRef, useState } from "react";
import { ChevronDownOutlineIcon } from "../icon/ChevronDownOutlineIcon";
import { ChevronUpOutlineIcon } from "../icon/ChevronUpOutlineIcon";
import { Body14Medium } from "../typography/Body14Medium";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  categoryIds: number[];
  handleCategoryChange: (categoryId: number) => void;
}

export const ChildItemCategoryFilter: React.FC<Props> = ({
  categoryIds,
  handleCategoryChange,
}) => {
  const [categories, setCategories] = useState<CategoryDto[]>([]);
  // const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([]);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const getCategoryAll = async () => {
    try {
      const response = await categoryService.getAll(false);
      if (!response.ok) {
        return;
      }
      setCategories([...response.data]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategoryAll();
  }, []);

  // useEffect(() => {
  //   handleCategoryChange(selectedCategoryIds);
  // }, [selectedCategoryIds]);

  // const handleCheckboxChange = (categoryId: number) => {
  //   setSelectedCategoryIds((prevSelected) => {
  //     if (prevSelected.includes(categoryId)) {
  //       return prevSelected.filter((id) => id !== categoryId);
  //     } else {
  //       return [...prevSelected, categoryId];
  //     }
  //   });
  // };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <Button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        color={ButtonColor.TRANSPARENT_OUTLINE}
        size="sx"
        className={`flex items-center justify-between w-[348px] h-[42px] px-[12px] ${
          categoryIds.length > 0
            ? "text-semantic-success-success-primary"
            : "text-primary-black"
        }`}
      >
        {/* <FilterOutlineIcon size={18} className="mr-[8px] mt-[2px]" /> */}
        <div className="flex justify-between w-[318px]">
          <Body14Regular>카테고리 필터</Body14Regular>
          <div className="w-[16px] h-[16px] ml-[8px] mt-[2px]">
            {open ? (
              <ChevronUpOutlineIcon
                color={`${
                  categoryIds.length > 0
                    ? "text-semantic-success-success-primary"
                    : "text-primary-black"
                }`}
              />
            ) : (
              <ChevronDownOutlineIcon
                color={`${
                  categoryIds.length > 0
                    ? "text-semantic-success-success-primary"
                    : "text-primary-black"
                }`}
              />
            )}
          </div>
        </div>
      </Button>

      {open && (
        <div className="absolute top-[52px] z-40 w-fit bg-white border border-gray-300 rounded-md shadow-lg">
          {categories.map((category) => (
            <div
              onClick={() => handleCategoryChange(category.id)}
              key={category.id}
              className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <Checkbox
                color={
                  categoryIds.includes(category.id) ? CheckboxColor.DARK : ""
                }
                checked={categoryIds.includes(category.id)}
                onChange={() => handleCategoryChange(category.id)}
              />
              <Body14Medium className="text-semantic-text-body ml-[8px]">
                {category.name}
              </Body14Medium>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
